import { selectResource } from '../resource/resourceSelectors'

export const selectLoanData = state => selectResource(state).loan?.data || {}
